import { api } from "./api";

export const getNotificationsAPI = (params) => {
  return api.get(`notifications/list`, params);
};

export const readNotificationAPI = (ids) => {
  return api.post(`notifications/mark-as-read`, { ids });
};
